import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import {
  GooglePayCreditCardNetworks as GooglePayCreditCardNetworksServer,
  type IGooglePayPaymentMethod as IGooglePayPaymentMethodServer,
} from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { GooglePayCreditCardNetworks, type GooglePayPaymentMethod } from '../../../types/PaymentMethods';

const GooglePayCreditCardNetworksMap: Record<GooglePayCreditCardNetworksServer, GooglePayCreditCardNetworks> = {
  [GooglePayCreditCardNetworksServer.Amex]: GooglePayCreditCardNetworks.Amex,
  [GooglePayCreditCardNetworksServer.Discover]: GooglePayCreditCardNetworks.Discover,
  [GooglePayCreditCardNetworksServer.Interac]: GooglePayCreditCardNetworks.Interac,
  [GooglePayCreditCardNetworksServer.Jcb]: GooglePayCreditCardNetworks.Jcb,
  [GooglePayCreditCardNetworksServer.MasterCard]: GooglePayCreditCardNetworks.MasterCard,
  [GooglePayCreditCardNetworksServer.Visa]: GooglePayCreditCardNetworks.Visa,
  [GooglePayCreditCardNetworksServer.Electron]: GooglePayCreditCardNetworks.Electron,
  [GooglePayCreditCardNetworksServer.Elo]: GooglePayCreditCardNetworks.Elo,
  [GooglePayCreditCardNetworksServer.EloDebit]: GooglePayCreditCardNetworks.EloDebit,
  [GooglePayCreditCardNetworksServer.Maestro]: GooglePayCreditCardNetworks.Maestro,
};

function mapSupportedNetworksToCommon(
  supportedNetworks: GooglePayCreditCardNetworksServer[],
): GooglePayCreditCardNetworks[] {
  return supportedNetworks && supportedNetworks.map((value) => GooglePayCreditCardNetworksMap[value]);
}

const GooglePayAuthMethodsMap: Record<
  IGooglePayPaymentMethodServer['googlePay']['panTypes'][number],
  GooglePayPaymentMethod['googlePay']['allowedAuthMethods'][number]
> = {
  FPAN: 'PAN_ONLY',
  DPAN: 'CRYPTOGRAM_3DS',
};

function mapAllowedAuthMethodsToCommon(
  panTypes: IGooglePayPaymentMethodServer['googlePay']['panTypes'],
): GooglePayPaymentMethod['googlePay']['allowedAuthMethods'] {
  return panTypes.map((type) => GooglePayAuthMethodsMap[type]);
}

export function mapGooglePayPaymentMethodToCommon(
  paymentMethod: IGooglePayPaymentMethodServer,
): GooglePayPaymentMethod {
  const { merchantCountry, supportedNetworks, panTypes } = paymentMethod[PaymentMethod.GooglePay];

  return {
    ...paymentMethod,
    [PaymentMethod.GooglePay]: {
      merchantCountry,
      allowedAuthMethods: mapAllowedAuthMethodsToCommon(panTypes),
      allowCardNetworks: mapSupportedNetworksToCommon(supportedNetworks),
    },
  };
}
